import _ from 'lodash'
import { systemFontList } from '@/config/system-font.js'
import { defaultFont } from '@/store/creative/template/config'
import { getAssetNoShelfFonts } from '@/api/common/asset'

async function getForbiddenFont(languages, fontList, assetFontList) {
  const forbiddenFontRes = await getAssetNoShelfFonts({
    tool: 1,
    page_size: 1000,
  })
  const forbiddenFontList = _.get(forbiddenFontRes, 'data.data.list') || []
  const forbidden = {}
  const inFontList = (font) => {
    return fontList.some((item) => item.value === font)
  }
  // 自定义字体查询
  const inAssetFontList = (font) => {
    return assetFontList.some((item) => item.value === font)
  }
  // 下架字体的查找
  const inForbiddenFontList = (font) => {
    return forbiddenFontList.filter((item) => item.postscript_name === font)
  }
  // 相同语言下相同下架字体仅保留一个
  const filterFont = (list, fontname) => {
    return list.some((item) => item.forbiddenFont.postscript_name === fontname)
  }
  // 遍历语言列表
  for (const key in languages) {
    forbidden[key] = []
    // 遍历语言下所有文案
    for (const label in languages[key]) {
      // 获取文案设置的字体
      const fontname = _.get(languages[key][label], 'style.font') || ''
      // 记录不在字体列表，不在系统列表的文本
      if (
        fontname &&
        !inFontList(fontname) &&
        !inAssetFontList(fontname) &&
        systemFontList.indexOf(fontname) === -1 &&
        !filterFont(forbidden[key], fontname)
      ) {
        forbidden[key].push({
          forbiddenFont: inForbiddenFontList(fontname)[0] || {
            postscript_name: fontname,
          },
          newFont: {},
        })
      }
    }
    if (!forbidden[key].length) {
      delete forbidden[key]
    }
  }
  return forbidden
}

export default async function checkJsonConfigForbiddenFont(
  languages,
  fontList,
  assetFontList,
) {
  const forbiddenList = await getForbiddenFont(
    languages,
    fontList,
    assetFontList,
  )
  return {
    status: JSON.stringify(forbiddenList) !== '{}',
    forbiddenList,
  }
}

// 处理pt i18nResource数据（兼容pt多版本）
export function dealPtVersionI18n(i18nResource) {
  const languagesJsonConfig = {}
  for (const i18nKey in i18nResource) {
    const i18nItem = i18nResource[i18nKey]
    for (const dataKey in i18nItem) {
      const dataItem = i18nItem[dataKey].data
      for (const languageKey in dataItem) {
        const styleItem = dataItem[languageKey]
        if (!_.has(languagesJsonConfig, languageKey)) {
          languagesJsonConfig[languageKey] = {}
        }
        languagesJsonConfig[languageKey][i18nItem[dataKey].id] = styleItem
      }
    }
  }
  return languagesJsonConfig
}

// 转成对象的形式 {en:{key:''}}
export function dealForbiddenFont(data) {
  const replaceLanguage = {}
  for (const languageKey in data) {
    const languageItem = {}
    for (const key in data[languageKey]) {
      let postscript_name =
        data[languageKey][key].newFont.postscript_name || defaultFont
      if (postscript_name === 'system-font') {
        postscript_name = defaultFont
      }
      languageItem[data[languageKey][key].forbiddenFont.postscript_name] =
        postscript_name
    }
    replaceLanguage[languageKey] = languageItem
  }
  return replaceLanguage
}
